var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useResultCategoryOutletContext } from '@/components/results-category/hooks/use-result-category-outlet-context.hook';
import otcBenefitsSideImage from '@/components/results-category/images/otc-benefits-side-image.webp';
import { Typography } from '@mui/material';
import { ContentCard } from '@/components/results-category/components/content-card.component';
import { Fragment } from 'react';
import { NavigationButton } from '@/components/navigation-button.component';
import { Typeform } from './typeform/typeform.component';
import { LexieButton } from '@/components/lexie-button.component';
var bulletPoints = [
    {
        title: 'Affordable:',
        description: 'Save up to 80% compared to prescription hearing aids.',
    },
    {
        title: 'Accessible:',
        description: 'Purchase online or in stores, set up at home, and start using immediately.',
    },
    {
        title: 'No prescription needed:',
        description: 'Skip the audiologist visit and prescription process.',
    },
    {
        title: 'Customizable:',
        description: 'Personalize settings with adjustable domes, wires, and a free mobile app for control.',
    },
];
export function OtcBenefits() {
    useResultCategoryOutletContext({
        sideImage: otcBenefitsSideImage,
        heading: (_jsx("span", __assign({ className: "md:font-extrabold text-3xl md:text-4xl md:leading-loose md:text-center text-left leading-10 inline-block" }, { children: "OTC hearing aid benefits" }))),
        step: 3,
    });
    return (_jsxs("div", __assign({ className: 'flex max-w-full flex-col space-y-7 md:space-y-6 md:-mt-14 -mt-4 md:mx-8' }, { children: [_jsx(Typography, __assign({ className: 'max-w-2xl px-6 text-lg md:text-xl md:w-full' }, { children: "OTC hearing aids can be purchased directly, without a prescription or audiologist fitting, thanks to regulations that went into effect in late 2022. They are designed for adults with perceived mild-to-moderate hearing loss." })), _jsx(ContentCard, __assign({ className: 'md:flex items-center justify-center', isGradient: true }, { children: _jsx(Typography, __assign({ className: 'flex-row text-sm font-medium leading-[18px]' }, { children: bulletPoints.map(function (_a) {
                        var title = _a.title, description = _a.description;
                        return (_jsxs(Fragment, { children: [_jsx("span", __assign({ className: 'text-vivid-blue font-bold' }, { children: title })), ' ', _jsx("span", __assign({ className: 'text-navy-blue' }, { children: description })), _jsx("br", {})] }, title));
                    }) })) })), _jsx(Typography, __assign({ className: 'md:mx-auto text-base font-medium mx-8' }, { children: "FDA-cleared OTC hearing aids are safe, effective, and meet high standards." })), _jsxs("div", __assign({ className: 'mx-8 flex flex-col-reverse items-center justify-center md:mx-0 md:flex-row md:space-x-5 md:space-y-0' }, { children: [_jsx(NavigationButton, __assign({ variant: 'outlined', className: 'mt-4 w-full py-3 text-xs md:mt-0 md:basis-1/2 self-stretch', navigate: '/result-category/mild' }, { children: "previous" })), _jsx(Typeform, __assign({ typeformId: 'lUZB4dI9', className: 'md:basis-1/2 md:mr-5 self-stretch' }, { children: _jsx(LexieButton, __assign({ variant: 'contained', className: 'w-full py-3 text-xs md:mt-0' }, { children: "Find my perfect lexies" })) }))] }))] })));
}
